import { render, staticRenderFns } from "./ResidentCheckDeleteModal.vue?vue&type=template&id=0199b1b2&lang=pug"
import script from "./ResidentCheckDeleteModal.vue?vue&type=script&lang=ts"
export * from "./ResidentCheckDeleteModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports